import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { StaffMainComponent } from './component/staffs/staff-main/staff-main.component';
import { StaffsCreateComponent } from './component/staffs/staffs-create/staffs-create.component';
// import { TripsHistoryComponent } from './component/dispatch-center/trips-history/trips-history.component';
import { DispatchDashboardComponent } from './component/dashboard/dashboard/dashboard.component';
import { EditUserProfileComponent } from './component/user profile/edit-user-profile/edit-user-profile.component';
import { AuthorizationGuard } from './service/auth-guard/authorization-guard.service';
import { DriverListComponent } from './component/drivers/driver-list/driver-list.component';
import { CreateDriverComponent } from './component/drivers/create-driver/create-driver.component';
// import { DriverProfileDashboardComponent } from './component/drivers/driver-profile-dashboard/driver-profile-dashboard.component';
import { CorporateuserComponent } from './component/corporate-user/corporate-user-list/corporate-user.component';
import { CorporateAddUserComponent } from './component/corporate-user/corporate-add-user/corporate-add-user.component';
import { FleetListComponent } from './component/fleet/fleet-list/fleet-list.component';
import { CreateFleetComponent } from './component/fleet/create-fleet/create-fleet.component';
import { DriverDistributionsComponent } from './component/driver-distributions/driver-distributions-list/driver-distributions.component';
// tslint:disable-next-line: max-line-length
import { DriverDistributionsCreateComponent } from './component/driver-distributions/driver-distributions-create/driver-distributions-create.component';
import { DriverAlertComponent } from './component/driver-alert/driver-alert/driver-alert.component';
import { HelpingMaterialListComponent } from './component/helping-material/helping-material-list/helping-material-list.component';
import { ParseTripsComponent } from './component/broker-parser/parse-trips/parse-trips.component';
import { UnassignedComponent } from './component/assigned-trips/unassigned/unassigned.component';
import { VerifiedTripLogsComponent } from './component/billing/verified-trip-logs/verified-trip-logs.component';
import { NewTripComponent } from './component/assigned-trips/new-trip/new-trip.component';
import { NemtStatisticsComponent } from './component/kpis/nemt-statistics/nemt-statistics.component';
import { NemtReportComponent } from './component/kpis/nemt-report/nemt-report.component';
import { DynamicFareListComponent } from './component/dynamic-fare/dynamic-fare-list/dynamic-fare-list.component';
import { DynamicFareAddComponent } from './component/dynamic-fare/dynamic-fare-add/dynamic-fare-add.component';
import { EarningsComponent } from './component/reports/earnings/earnings.component';
import { AdminNemtReportComponent } from './component/superAdmin/admin-nemt-report/admin-nemt-report.component';
import { DriverBreakdownComponent } from './component/kpis/driver-breakdown/driver-breakdown.component';
import { NotificationDetailsComponent } from './notification/notification-details/notification-details.component';
// import { AccidnetsListComponent } from './component/accidents/accidnets-list/accidnets-list.component'
// import { AddAccidentComponent } from './component/accidents/add-accident/add-accident.component';
// import { AccidentDetailInTailwindFormComponent } from './component/accidents/accident-detail-in-tailwind-form/accident-detail-in-tailwind-form.component';
import { HelpingMaterialPdfComponent } from './component/helping-material/helping-material-pdf/helping-material-pdf.component';
import { LogsComponent } from './component/offered-trips/logs/logs.component';
import { MemberListComponent } from './component/members/member-list/member-list.component';
import { CreateMemberComponent } from './component/members/create-member/create-member.component';
import { OutstandingComponent } from './component/assigned-trips/outstanding/outstanding.component';
import { DriverInvoicesComponent } from './component/drivers/driver-invoices/driver-invoices.component';
import { DirtRoadComponent } from './component/assigned-trips/dirt-road/dirt-road.component';
import { DriverTimelinesComponent } from './component/drivers/driver-timelines/driver-timelines.component';
import { TripDetailModelComponent } from './modals/trip-detail-model/trip-detail-model.component';
import { ZDatesComponent } from './component/page-not-found/z-dates.component';
import { OfferedComponent } from './component/assigned-trips/offered/offered.component';
import { BrokerSettingComponent } from './component/broker-parser/broker-setting/broker-setting.component';
import { BrokerSettingListComponent } from './component/broker-parser/broker-setting-list/broker-setting-list.component';
import { AuthTokenComponent } from './component/auth-token/auth-token.component';
import { CompaniesListComponent } from './component/companies/companies-list/companies-list.component';
import { CreateCompanyComponent } from './component/companies/create-company/create-company.component';
import { QuarterListComponent } from './component/superAdmin/quarters/quarter-list/quarter-list.component';
import { InvoiceSettingListComponent } from './component/superAdmin/invoice-settings/invoice-setting-list/invoice-setting-list.component';
import { NemtProTipsComponent } from './component/helping-material/nemt-pro-tips/nemt-pro-tips/nemt-pro-tips.component';
import { StatisticsDetailsComponent } from './component/kpis/nemt-statistics-details/statistics-details/statistics-details.component';
import { ManifestComponent } from './component/assigned-trips/manifest/manifest.component';
import { StandingOrdersV2Component } from './component/assigned-trips/standing-orders-v2/standing-orders-v2.component';
import { NemtSuperProTipsComponent } from './component/superAdmin/nemt-super-tips/nemt-super-pro-tips/nemt-super-pro-tips.component';
import { CreateTipsComponent } from './component/superAdmin/create-pro-tips/create-tips/create-tips.component';
import { AdjustmentComponent } from './component/billing/adjustment/adjustment.component';
import { GanttChartComponent } from './component/assigned-trips/gantt-chart/gantt-chart.component';
import { VehicleInspectionComponent } from './component/reports/inspection/vehicle-inspection/vehicle-inspection.component';
import { AddVehicleInspectionComponent } from './component/reports/inspection/add-vehicle-inspection/add-vehicle-inspection.component';
import { UserRoles } from './component/shared/layout/menu-service/menu.service';
import { UnAuthorizationGuard } from './service/non-auth-guard/unauthorization-guard.service';
import { DailyVehicleInspectionComponent } from './component/reports/inspection/daily-vehicle-inspection/daily-vehicle-inspection/daily-vehicle-inspection.component';
import { TrfsTemplatesComponent } from './component/billing/trfs-templates/trfs-templates.component';
import { CtcClaimedTripsComponent } from './component/assigned-trips/offered/ctc-claimed-trips/ctc-claimed-trips.component';
import { DriverExpensesComponent } from './component/maintenances/driver-expenses/driver-expenses.component';
import { VehicleExpensesComponent } from './component/maintenances/vehicle-expenses/vehicle-expenses.component';
import { MaintenanceStatsComponent } from './component/maintenances/maintenance-stats/maintenance-stats.component';
import { DriverLoadV2Component } from './component/assigned-trips/driver-load-v2/driver-load-v2.component';
import { DriverScoreComponent } from './component/reports/driver-score/driver-score.component';
import { RoutingWrapperComponent } from './component/assigned-trips/outstanding/routing-wrapper/routing-wrapper.component';
import { InspectionWrapperComponent } from './component/reports/inspection/inspection-wrapper/inspection-wrapper.component';
import { OperationsV2Component } from './component/assigned-trips/operations-v2/operations-v2.component';
import { DriverTimelinesV2Component } from './component/drivers/driver-timelines-V2/driver-timelines-v2/driver-timelines-v2.component';
import { AddTripPurposesComponent } from './component/trip-purposes/trip-purposes-add/trip-purposes-add.component';
import { TripPurposesListComponent } from './component/trip-purposes/trip-purposes-list/trip-purposes-list.component';
import { DriverAmendmentsComponent } from './component/drivers/driver-amendments/driver-amendments/driver-amendments.component';
import { AddLevelOfServiceComponent } from './component/level-of-service/add-level-of-service/add-level-of-service.component';
import { LevelOfServiceComponent } from './component/level-of-service/level-of-service-list/level-of-service-list.component';
import { AddDriverAmendmentsComponent } from './component/drivers/driver-amendments/add-driver-amendments/add-driver-amendments.component';
import { AdminEarningReportComponent } from './component/superAdmin/admin-earning-report/admin-earning-report.component';
import { DriverWrapperComponent } from './component/drivers/driver-wrapper/driver-wrapper.component';
import { ServiceAreasListingComponent } from './component/service-areas/service-areas-listing/service-areas-listing.component';
import { ServiceAreasAddComponent } from './component/service-areas/service-areas-add/service-areas-add.component';
import { DriverCredentialsComponent } from './component/drivers/driver-credentials/driver-credentials.component';
import { AddSpaceTypesComponent } from './component/level-of-service/add-space-types/add-space-types.component';
import { SpaceTypesListComponent } from './component/level-of-service/space-types-list/space-types-list.component';
import { AddEquipmentComponent } from './component/equipments/add-equipment/add-equipment.component';
import { EquipmentListComponent } from './component/equipments/equipment-list/equipment-list.component';
import { FleetCredentialsComponent } from './component/fleet/fleet-credentials/fleet-credentials.component';
import { PrimaryDiagnosisListComponent } from './component/primary-diagnosis/primary-diagnosis-list/primary-diagnosis-list.component';
import { AddPrimaryDiagnosisComponent } from './component/primary-diagnosis/add-primary-diagnosis/add-primary-diagnosis.component';
import { ModifierCodeListComponent } from './component/modifier-codes/modifier-code-list/modifier-code-list.component';
import { AddModifierCodeComponent } from './component/modifier-codes/add-modifier-code/add-modifier-code.component';
import { ConfigurationsComponent } from './component/corporate-user/configurations/configurations.component';
import { ConfigurationsListComponent } from './component/corporate-user/configurations-list/configurations-list.component';
import { CorporateWrapperComponent } from './component/corporate-user/corporate-wrapper/corporate-wrapper.component';
import { SmsDashboardComponent } from './component/sms/sms-dashboard/sms-dashboard.component';
import { ViolationsSetFormComponent } from './component/violations-sets/violations-set-form/violations-set-form.component';
import { PlannerComponent } from './component/assigned-trips/trip-planner/planner/planner.component';
import { CreateQuarterComponent } from './component/superAdmin/quarters/create-quarter/create-quarter.component';
import { AddonListComponent } from './component/addons/addon-list/addon-list.component';
import { AddAddonComponent } from './component/addons/add-addon/add-addon.component';
import { TripReportsComponent } from './component/reports/trip-reports/trip-reports.component';
import { AccidentalReportListComponent } from './component/reports/accidental-report/accidental-report-list/accidental-report-list.component';
import { DriverGrievanceComponent } from './component/reports/driver-grievance/driver-grievance/driver-grievance.component';
import { EdiReportsComponent } from './component/billing/edi-parser/edi-reports/edi-reports.component';
import { AddEdiReportComponent } from './component/billing/edi-parser/add-edi-report/add-edi-report.component';
import { DriverStatisticsComponent } from './component/reports/driver-statistics/driver-statistics.component';
import { OutboundingComponent } from './component/reports/outbounding/outbounding.component';
import { AnnouncementListComponent } from './component/extras/announcement/announcement-list/announcement-list.component';
import { AddAnnouncementComponent } from './component/extras/announcement/add-announcement/add-announcement.component';
import { FleetEquipmentsComponent } from './component/fleet/capacity-planning/fleet-equipments.component';
import { LateForecastComponent } from './component/assigned-trips/late-forecast/late-forecast.component';
import { MapViewComponent } from './component/superAdmin/map-view/map-view.component';
import { FarmoutTripsComponent } from './component/assigned-trips/farmout/farmout-trips/farmout-trips.component';
import { AddMfbComponent } from './component/miles-for-buck/mfb/add-mfb/add-mfb.component';
import { AssistWrapperComponent } from './component/miles-for-buck/assist-wrapper/assist-wrapper.component';
import { AddAssistComponent } from './component/miles-for-buck/assist/add-assist/add-assist.component';
import { DashboardWrapperComponent } from './component/miles-for-buck/dashboard-wrapper/dashboard-wrapper.component';
import { HolidaysListComponent } from './component/extras/holidays/holidays-list/holidays-list.component';
import { AddHolidayComponent } from './component/extras/holidays/add-holiday/add-holiday.component';
import { AddChecklistComponent } from './component/spaceType-checklist/add-checklist/add-checklist.component';
import { ChecklistComponent } from './component/spaceType-checklist/checklist/checklist.component';
import { DriverLoadWrapperComponent } from './component/assigned-trips/driver-load-wrapper/driver-load-wrapper.component';
import { PlannerMapperAddComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-mapper-add/planner-mapper-add.component';
import { PlannerMapperListComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-template-list/planner-mapper-list.component';
import { PlannerTemplateListComponent } from './component/assigned-trips/trip-planner/planner-template/planner-template-list/planner-template-list.component';
import { PlannerTemplateAddComponent } from './component/assigned-trips/trip-planner/planner-template/planner-template-add/planner-template-add.component';
import { NemtReportWrapperComponent } from './component/kpis/nemt-report-wrapper/nemt-report-wrapper.component';
import { FarmoutWrapperComponent } from './component/assigned-trips/farmout/farmout-wrapper/farmout-wrapper.component';
import { PlaygroundComponent } from './component/assigned-trips/playground/playground.component';
import { DriverTrackingComponent } from './component/drivers/driver-tracking/driver-tracking.component';
import { GanttChartV2Component } from './component/assigned-trips/gantt-chart-v2/gantt-chart-v2.component';
import { PlannerMapperWrapperComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-mapper-wrapper/planner-mapper-wrapper.component';
import { PlannerDriverMapperAddComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-driver-mapper-add/planner-driver-mapper-add.component';
import { DriverShiftOverrideComponent } from './component/drivers/shift-override/driver-shift-override/driver-shift-override.component';
import { DriverShiftOverrideListComponent } from './component/drivers/shift-override/driver-shift-override-list/driver-shift-override-list.component';
import { BucketWrapperComponent } from './component/assigned-trips/bucket-wrapper/bucket-wrapper.component';
import { DriverEarningsComponent } from './component/reports/driver-earnings/driver-earnings.component';
import { PushToTalkWrapperComponent } from './component/push-to-talk/push-to-talk-wrapper/push-to-talk-wrapper.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { TripSheetComponent } from './component/assigned-trips/trip-sheet/trip-sheet.component';
import { TripSheetV2Component } from './component/assigned-trips/trip-sheet-v2/trip-sheet-v2.component';
import { CredentialedDriversListComponent } from './component/credentialing/drivers/credentialed-drivers-list/credentialed-drivers-list.component';
import { AddCredentialedDriverComponent } from './component/credentialing/drivers/add-credentialed-driver/add-credentialed-driver.component';

const routes: Routes = [
  {
    path: 'login', component: SignInComponent, canActivate: [UnAuthorizationGuard]
  },
  {
    path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [UnAuthorizationGuard]
  },
  {
    path: 'password/reset/:token/:role', component: ResetPasswordComponent, canActivate: [UnAuthorizationGuard]
  },

  // Dispatch Center
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard', component: DispatchDashboardComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  { path: 'auth-token/:token', component: AuthTokenComponent },
  // Operations
  {
    path: 'operations', component: OperationsV2Component, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  // {
  //   path: 'operations-v2', component: DashboardComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR]
  //   }
  // },
  {
    path: 'operations/parsetrips', component: ParseTripsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },

  {
    path: 'operations/broker-configuration', component: BrokerSettingListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'operations/broker-configuration/add', component: BrokerSettingComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'operations/broker-configuration/:id/edit', component: BrokerSettingComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },



  // Trips
  {
    path: 'trips', component: UnassignedComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR, UserRoles.ACCOUNTANT]
    }
  },
  {
    path: 'trips/new', component: NewTripComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'trips/:id/edit', component: NewTripComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'trips/:id/adjust', component: AdjustmentComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR, UserRoles.ACCOUNTANT]
    }
  },
  {
    path: 'trips/drivers-load', component: DriverLoadWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'trips/buckets', component: BucketWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'trips/forecast', component: LateForecastComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'trips/standing-orders', component: StandingOrdersV2Component, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'farmout', component: FarmoutWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },
  {
    path: 'trips/trip-sheet', component: TripSheetComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  // {
  //   path: 'trips/trip-sheet', component: GanttChartV2Component, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
  //   }
  // },
  // {
  //   path: 'trips/trip-sheet/v2', component: TripSheetComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
  //   }
  // },
  // {
  //   path: 'trips/trip-sheet/v3', component: TripSheetV2Component, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
  //   }
  // },
  // {
  //   path: 'trips/trip-sheet/v2', component: GanttChartV2Component, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
  //   }
  // },
  {
    path: 'trips/offered', component: OfferedComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'trips/offered/tripslogs', component: LogsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },

  {
    path: 'trips/offered/ctc-claimed-trips', component: CtcClaimedTripsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },


  {
    path: 'trips/grouping', component: RoutingWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },

  {
    path: 'trips/dirt-road', component: DirtRoadComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_REP, UserRoles.CALL_CENTER_MNGR]
    }
  },

  // Planner

  { path: 'planner', redirectTo: 'planner/playground', pathMatch: 'full' },
  {
    path: 'planner/playground', component: PlaygroundComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.ACCOUNTANT, UserRoles.CALL_CENTER_REP, UserRoles.DISPATCHER]
    }
  },
  {
    path: 'planner/schedule', component: PlannerComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'planner/mapper', component: PlannerMapperWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'planner/mapper/add', component: PlannerMapperAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'planner/mapper/:id/edit', component: PlannerMapperAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'planner/mapper/add-driver', component: PlannerDriverMapperAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'planner/mapper/:id/edit-driver', component: PlannerDriverMapperAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'planner/template', component: PlannerTemplateListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'planner/template/add', component: PlannerTemplateAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'planner/template/:id/edit', component: PlannerTemplateAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  // Holidays
  {
    path: 'planner/holidays', component: HolidaysListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'planner/holidays/add', component: AddHolidayComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },
  {
    path: 'planner/holidays/:id/edit', component: AddHolidayComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },
  {
    path: 'planner/violation', component: ViolationsSetFormComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER]
    }
  },

  // {
  //   path: 'planner', component: PlannerComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.ACCOUNTANT, UserRoles.CALL_CENTER_REP, UserRoles.DISPATCHER]
  //   }
  // },


  // Manifest
  {
    path: 'manifest', component: ManifestComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.ACCOUNTANT, UserRoles.CALL_CENTER_REP, UserRoles.DISPATCHER]
    }
  },

  // Credentialli
  { path: 'credentialing', redirectTo: 'credentialing/drivers', pathMatch: 'full' },

  // Credentails - Drivers
  {
    path: 'credentialing/drivers', component: DriverListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'credentialing/drivers/add', component: CreateDriverComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'credentialing/drivers/:id/edit', component: CreateDriverComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'credentialing/drivers/:id/documents', component: DriverCredentialsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'credentialing/credential-drivers', component: CredentialedDriversListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'credentialing/credential-drivers/add', component: AddCredentialedDriverComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'credentialing/credential-drivers/:id/edit', component: AddCredentialedDriverComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'timelines/shift-override', component: DriverShiftOverrideListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'timelines/shift-override/add', component: DriverShiftOverrideComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'timelines/shift-override/:overrideId/edit', component: DriverShiftOverrideComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'credentialing/drivers/:id/shift-override', component: DriverShiftOverrideListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'credentialing/drivers/:id/shift-override/add', component: DriverShiftOverrideComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'credentialing/drivers/:id/shift-override/:overrideId/edit', component: DriverShiftOverrideComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'credentialing/drivers/tracking', component: DriverTrackingComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  // { path: 'credentialing/drivers/:id/profile', component: DriverProfileDashboardComponent, canActivate: [AuthorizationGuard],data: {
  // role: [ UserRoles.FULLACCESS]
  //     } },

  // Credentails - Fleet
  {
    path: 'fleet/vehicles', component: FleetListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'fleet/vehicles/add', component: CreateFleetComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'fleet/vehicles/:id/edit', component: CreateFleetComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },
  {
    path: 'fleet/vehicles/:id/documents', component: FleetCredentialsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
    }
  },

  {
    path: 'fleet/equipment-planning', component: FleetEquipmentsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  // {
  //   path: 'checklist', component: ChecklistComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS]
  //   }
  // },
  // {
  //   path: 'checklist/add', component: AddChecklistComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS]
  //   }
  // },
  // {
  //   path: 'checklist/:id/edit', component: AddChecklistComponent, canActivate: [AuthorizationGuard],
  //   data: {
  //     role: [UserRoles.FULLACCESS]
  //   }
  // },


  // Credentails - Staff
  {
    path: 'credentialing/staff', component: StaffMainComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.COMPANY]
    }
  },
  {
    path: 'credentialing/staff/add', component: StaffsCreateComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.COMPANY]
    }
  },
  {
    path: 'credentialing/staff/:id/edit', component: StaffsCreateComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.COMPANY]
    }
  },

  // Credentails - Members
  {
    path: 'credentialing/members', component: MemberListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN, UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  {
    path: 'credentialing/members/add', component: CreateMemberComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN, UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  {
    path: 'credentialing/members/:id/edit', component: CreateMemberComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN, UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },

  // Credentails - Corporate Users
  {
    path: 'credentialing/fundingsource', component: CorporateWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  {
    path: 'credentialing/fundingsource/add', component: CorporateAddUserComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  {
    path: 'credentialing/fundingsource/:id/edit', component: CorporateAddUserComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  {
    path: 'credentialing/fundingsource/configuration/add', component: ConfigurationsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  {
    path: 'credentialing/fundingsource/configuration/:id/edit', component: ConfigurationsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },

  // Credentails - Companies
  {
    path: 'credentialing/companies', component: CompaniesListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'credentialing/companies/add', component: CreateCompanyComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'credentialing/companies/:id/edit', component: CreateCompanyComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },

  //Credentials - Super Amin
  {
    path: 'credentialing/quarterpanels', component: QuarterListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'credentialing/quarterpanels/add', component: CreateQuarterComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'credentialing/quarterpanels/:id/edit', component: CreateQuarterComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  //Fleet
  { path: 'fleet', redirectTo: 'fleet/vehicles', pathMatch: 'full' },

  //Level of Service
  {
    path: 'fleet/levelofservice', component: LevelOfServiceComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },
  {
    path: 'fleet/levelofservice/:id/edit', component: AddLevelOfServiceComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'fleet/levelofservice/add', component: AddLevelOfServiceComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  //Service Areas
  {
    path: 'fleet/service-areas', component: ServiceAreasListingComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },

  {
    path: 'fleet/service-areas/add', component: ServiceAreasAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },
  {
    path: 'fleet/service-areas/:id/edit', component: ServiceAreasAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    }
  },

  //Space Tyes
  {
    path: 'fleet/spaceTypes/:id/edit', component: AddSpaceTypesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'fleet/spaceTypes/add', component: AddSpaceTypesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'fleet/spaceTypes', component: SpaceTypesListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  //Equipments
  {
    path: 'fleet/equipment/:id/edit', component: AddEquipmentComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'fleet/equipment/add', component: AddEquipmentComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'fleet/equipment', component: EquipmentListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  //Addons
  {
    path: 'rates/addons/:id/edit', component: AddAddonComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },

  {
    path: 'rates/addons/add', component: AddAddonComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },

  {
    path: 'rates/addons', component: AddonListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },

  //TimeSheet
  { path: 'timelines', redirectTo: 'timelines/dashboard', pathMatch: 'full' },
  {
    path: 'timelines/time-sheet', component: DriverTimelinesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL, UserRoles.DISPATCHER]
    }
  },
  {
    path: 'timelines/dashboard', component: DriverTimelinesV2Component, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL, UserRoles.DISPATCHER]
    }
  },
  {
    path: 'timelines/amendments', component: DriverAmendmentsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL, UserRoles.DISPATCHER]
    }
  },
  {
    path: 'timelines/amendments/add', component: AddDriverAmendmentsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL, UserRoles.DISPATCHER]
    }
  },

  // { path: 'mfb', redirectTo: 'mfb/driver', pathMatch: 'full' },
  // {
  //   path: 'mfb/driver', component: AssistWrapperComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
  //   }
  // },
  // {
  //   path: 'mfb/assist', component: AssistWrapperComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
  //   }
  // },
  // {
  //   path: 'mfb/driver/add', component: AddMfbComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
  //   }
  // },
  // {
  //   path: 'mfb/assist/add', component: AddAssistComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
  //   }
  // },
  // {
  //   path: 'mfb/assist/:id/edit', component: AddAssistComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
  //   }
  // },
  // {
  //   path: 'mfb/driver/:id/edit', component: AddMfbComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
  //   }
  // },
  // {
  //   path: 'mfb/dashboard', component: DashboardWrapperComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR,UserRoles.DISPATCHER_RMNGR, UserRoles.CREDENTIAL]
  //   }
  // },

  // Fares
  {
    path: 'rates', component: DynamicFareListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },
  {
    path: 'rates/add', component: DynamicFareAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },
  {
    path: 'rates/:id/edit', component: DynamicFareAddComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },
  {
    path: 'rates/distributions', component: DriverDistributionsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },
  {
    path: 'rates/distributions/add', component: DriverDistributionsCreateComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },
  {
    path: 'rates/distributions/:id/edit', component: DriverDistributionsCreateComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },

  // Add TripPurposes
  {
    path: 'rates/appointment-types', component: TripPurposesListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },
  {
    path: 'rates/appointment-types/add', component: AddTripPurposesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },
  {
    path: 'rates/appointment-types/:id/edit', component: AddTripPurposesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    }
  },

  // Reports
  { path: 'maintenances', redirectTo: 'maintenances/driver-expense', pathMatch: 'full' },
  {
    path: 'maintenances/driver-expense', component: DriverExpensesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'maintenances/vehicle-expense', component: VehicleExpensesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'maintenances/maintenance-stats', component: MaintenanceStatsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },


  // Reports
  { path: 'reports', redirectTo: 'reports', pathMatch: 'full' },

  {
    path: 'reports', component: TripReportsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  // {
  //   path: 'reports/earnings', component: EarningsComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
  //   }
  // },
  {
    path: 'reports/nemtreport', component: NemtReportWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'reports/statistics', component: NemtStatisticsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.ACCOUNTANT]
    }
  },
  {
    path: 'reports/statisticsdetails', component: StatisticsDetailsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.ACCOUNTANT]
    }
  },
  // {
  //   path: 'reports/breakdown', component: DriverBreakdownComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [ UserRoles.FULLACCESS]
  //     }
  // },
  // {
  //   path: 'reports/driver-invoice', component: DriverInvoicesComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
  //   }
  // },
  {
    path: 'reports/outbounding', component: OutboundingComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  {
    path: 'reports/vehicle-inspection', component: InspectionWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'reports/vehicle-inspection/add', component: AddVehicleInspectionComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'reports/vehicle-inspection/:id/edit', component: AddVehicleInspectionComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  // { path: 'reports/vehicle-inspection/daily', component: DailyVehicleInspectionComponent, canActivate: [AuthorizationGuard], data: {
  //   role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
  // } },


  {
    path: 'reports/accidental-report', component: AccidentalReportListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  {
    path: 'reports/drivergrievance', component: DriverGrievanceComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  {
    path: 'billing/edireports', component: EdiReportsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'billing/edireports/add', component: AddEdiReportComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },


  {
    path: 'reports/accidental-report', component: AccidentalReportListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  {
    path: 'reports/driver-score', component: DriverScoreComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'reports/driver-earnings', component: DriverEarningsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },
  {
    path: 'reports/driver-statistics', component: DriverStatisticsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },



  // For Super Admin
  {
    path: 'reports/superadmin/nemtreport', component: AdminNemtReportComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'reports/superadmin/earning', component: AdminEarningReportComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'quarterpanels', component: QuarterListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'quarterpanels/add', component: CreateQuarterComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'quarterpanels/:id/edit', component: CreateQuarterComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'providerinvoicesettings', component: InvoiceSettingListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'nemtprotips', component: NemtSuperProTipsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },

  {
    path: 'mapview', component: MapViewComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },

  {
    path: 'nemtprotips/add', component: CreateTipsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },
  {
    path: 'nemtprotips/:id/edit', component: CreateTipsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.ADMIN]
    }
  },

  //Billing
  { path: 'billing', redirectTo: 'billing/adjusted-trips', pathMatch: 'full' },
  {
    path: 'billing/adjusted-trips', component: VerifiedTripLogsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.ACCOUNTANT]
    }
  },
  {
    path: 'billing/trfs-templates', component: TrfsTemplatesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.ACCOUNTANT]
    }
  },

  //primary Diagnosis
  {
    path: 'billing/primary-diagnosis/:id/edit', component: AddPrimaryDiagnosisComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'billing/primary-diagnosis/add', component: AddPrimaryDiagnosisComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'billing/primary-diagnosis', component: PrimaryDiagnosisListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  //Modifier Code
  {
    path: 'billing/modifier-codes/:id/edit', component: AddModifierCodeComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'billing/modifier-codes/add', component: AddModifierCodeComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'billing/modifier-codes', component: ModifierCodeListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  // Support
  {
    path: 'support', component: ZDatesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    }
  },

  {
    path: 'support/push-to-talk', component: PushToTalkWrapperComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS]
    }
  },

  //SMS Dashboard
  {
    path: 'sms/dashboard', component: SmsDashboardComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    }
  },
  { path: 'support', redirectTo: 'support/chats', pathMatch: 'full' },

  {
    path: 'support/chats', component: DriverAlertComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    }
  },
  // Announcement
  {
    path: 'support/announcements', component: AnnouncementListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },
  {
    path: 'support/announcements/add', component: AddAnnouncementComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },
  {
    path: 'support/announcements/:id/edit', component: AddAnnouncementComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },

  {
    path: 'support/queries', component: DriverAlertComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS]
    }
  },



  // Profile
  {
    path: 'profile', component: EditUserProfileComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.COMPANY, UserRoles.ADMIN, UserRoles.ACCOUNTANT, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    }
  },

  // Notifications
  {
    path: 'notifications', component: NotificationDetailsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    }
  },

  // Helping Material
  { path: 'manual', redirectTo: 'manual/helpingmaterial', pathMatch: 'full' },
  {
    path: 'manual/helpingmaterial', component: HelpingMaterialListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    }
  },
  {
    path: 'manual/helpingmaterial/pdf/:id', component: HelpingMaterialPdfComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    }
  },

  {
    path: 'manual/nemtprotips', component: NemtProTipsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.FULLACCESS, UserRoles.DISPATCHER, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    }
  },


  // Not Found
  { path: '**', component: ZDatesComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
